import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
    Paper,
    Button
} from '@mui/material';
import { withStyles } from "@material-ui/core/styles";
import styles from './clients.module.scss';
import { useNavigate } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-regular-svg-icons';
import { Switch } from '@material-ui/core';
import { CommonConfirmationDialog } from '../../components/DialogComponent/SupplyDataDialog';


const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        "&$checked": {
            transform: "translateX(12px)",
            color: theme.palette.common.white,
            "& + $track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: "none",
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const DesktopClientTable = ({ clients, OnSwitchChange }) => {
    const navigate = useNavigate();

const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    client: null,
    newStatus: false,
  });

  const handleSwitchChange = (client) => {
    const newStatus = !client?.status;

    setConfirmationDialog({
      open: true,
      client: client,
      newStatus: newStatus,
    });
  };

  const handleConfirmStatusChange = () => {
    if (OnSwitchChange && confirmationDialog.client) {
      OnSwitchChange(confirmationDialog.client, confirmationDialog.newStatus);
    }

    setConfirmationDialog({
      open: false,
      client: null,
      newStatus: false,
    });
  };

  const handleCloseConfirmation = () => {
    setConfirmationDialog({
      open: false,
      client: null,
      newStatus: false,
    });
  };

    return (
        <div className={styles.desktopOnly}>
            <TableContainer component={Paper} className={styles.tableContainer}>
                <Table className={styles.table}>
                    <TableHead className='dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]'>
                        <TableRow>
                            <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Status</TableCell>
                            <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Client ID</TableCell>
                            <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Client Name</TableCell>
                            <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Contact</TableCell>
                            {/* <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Company</TableCell> */}
                            <TableCell className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Shifts</TableCell>
                            <TableCell align="right" className={`${styles.clientHeader} dark:text-[#94A3B8]`}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {clients?.length > 0 ? (
                            clients?.map(client => (
                                <TableRow key={client.id} className={`${styles.tableRow} bg-white dark:bg-[#1A1F2C] dark:[&>td]:!border-b-0`}>
                                    <TableCell>
                                        <div className={styles.statusWrapper}>
                                            {client?.shiftData && Object.keys(client?.shiftData)?.length > 0 && (
                                            <AntSwitch
                                                checked={client?.status}
                                                onChange={() => handleSwitchChange(client)}
                                                color="primary"
                                                name="switchStatus"
                                                inputProps={{ "aria-label": "switchStatus" }}
                                            />
                                            )}
                                            <span className={client.status ? styles.active : styles.inactive}>
                                                {!client?.status && (!client?.shiftData || Object.keys(client?.shiftData)?.length === 0) ? 'Pending' : client?.status ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                    </TableCell>

                                    <TableCell className={`${styles.mono} dark:text-white`}>{client?.clientNumbers}</TableCell>

                                    <TableCell>
                                        <div className={styles.clientNameWrapper}>
                                            {client.avatar ? (
                                                <Avatar src={client.avatar} alt={client.clientName} className={styles.avatar} />
                                            ) : (
                                                <Avatar className={styles.avatarFallback}>
                                                    {client?.clientName.charAt(0)}
                                                </Avatar>
                                            )}
                                            <div>
                                                <div className="d-flex flex-center">
                                                    <span className={`${styles.clientName} dark:text-white`}>{client?.clientName}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell>

                                    <TableCell>
                                        <div className={styles.contactInfo}>
                                            {client?.primaryContact && (
                                                <div className={styles.contactLine}>
                                                    <CallOutlinedIcon className={`${styles.iconTiny} dark:text-[#94A3B8]`} />
                                                    <span className='dark:text-[#94A3B8]'>{client?.primaryContact}</span>
                                                </div>
                                            )}
                                            {client?.email && (
                                                <div className={styles.contactLine}>
                                                    <MailOutlineIcon className={`${styles.iconTiny} dark:text-[#94A3B8]`} />
                                                    <span className={styles.truncate}>
                                                        <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${client?.email}`} rel="noopener noreferrer" target="_blank" className="resLinks" style={{ overflowWrap: "anywhere" }}>
                                                            {client?.email}
                                                        </a></span>
                                                </div>
                                            )}
                                        </div>
                                    </TableCell>

                                    {/* <TableCell>
                                        <div className={styles.companyWrapper}>
                                            <FontAwesomeIcon icon={faBuilding} className={`${styles.iconSmall} dark:text-[#94A3B8]`} />
                                            <span className='dark:text-white'>{client?.company}</span>

                                        </div>
                                    </TableCell> */}

                                    <TableCell>
                                        <div className={styles.shiftWrapper}>
                                            <CalendarMonthOutlinedIcon className={`${styles.iconSmall} dark:text-[#94A3B8]`} />
                                            <span className={styles.badge}>
                                                {client?.shiftData ? [...Object.keys(client?.shiftData)]?.length : ''} shifts
                                            </span>
                                        </div>
                                    </TableCell>

                                    <TableCell align="right">
                                        <div className={styles.actionButtons}>
                                            <Button
                                                variant="text"
                                                size="small"
                                                onClick={() => navigate(`/peoples/createClient/${client?.id}`)}
                                                startIcon={<VisibilityOutlinedIcon style={{ color: "#1565c0" }} />}
                                            >
                                                View
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center" className={`${styles.noResults} bg-white dark:bg-[#1A1F2C]`}>
                                    <span className='dark:text-gray-500'>No clients found matching your search criteria</span>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <CommonConfirmationDialog
                    open={confirmationDialog?.open}
                    onConfirm={handleConfirmStatusChange}
                    onClose={handleCloseConfirmation}
                    title={confirmationDialog?.newStatus ? "Active Client" : "Inactive Client"}
                    message={
                    confirmationDialog?.newStatus
                        ? "Are you sure you want to active this client?"
                        : "Are you sure you want to inactive this client?\nThis action will permanently revoke the client's access to their account, and it cannot be undone.\nPlease proceed only if you are certain."
                    }
                    // meessge1={confirmationDialog.client ? `Client: ${confirmationDialog.client.clientName}` : ''}
                    buttonTitle="Confirm"
                />
        </div>
    );
};

export default DesktopClientTable;
